import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Link } from "react-router-dom";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-cream">
      <Helmet>
        <title>Mentions légales — L'Ostréa Dégustation</title>
        <meta
          name="description"
          content="Mentions légales du site L'Ostréa Dégustation : éditeur, hébergeur et informations légales du restaurant de Mazères."
        />
        <link rel="canonical" href="https://restaurant-lostrea-mazeres.fr/mentions-legales" />
        <meta property="og:title" content="Mentions légales — L'Ostréa Dégustation" />
        <meta
          property="og:description"
          content="Mentions légales du site L'Ostréa Dégustation, restaurant à Mazères."
        />
        <meta property="og:url" content="https://restaurant-lostrea-mazeres.fr/mentions-legales" />
        <meta name="twitter:title" content="Mentions légales — L'Ostréa Dégustation" />
        <meta
          name="twitter:description"
          content="Mentions légales du site L'Ostréa Dégustation, restaurant à Mazères."
        />
      </Helmet>
      <Header alwaysScrolled />
      <main className="pt-24 pb-16">
        <div className="container-narrow px-4 mx-auto max-w-4xl">
          <article className="prose prose-lg max-w-none text-warm-brown">
            <h1 className="text-3xl md:text-4xl font-serif text-warm-brown mb-8">
              Mentions légales – L'Ostrea Dégustation
            </h1>

            <p className="text-sm text-warm-brown/70 mb-8">
              Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}
            </p>

            <p>
              Conformément aux dispositions des articles 6-III et 19 de la Loi n°2004-575 du 21 juin 2004 pour la
              confiance dans l'économie numérique (LCEN), il est précisé aux utilisateurs du site L'Ostrea Dégustation
              l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
            </p>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Éditeur du site</h2>
            <p>
              L'Ostrea Dégustation – Société par actions simplifiée (SAS)
              <br />
              SIREN : 928 372 812
              <br />
              SIRET : 928 372 812 00018
              <br />
              Numéro de TVA intracommunautaire : FR31928372812
              <br />
              Forme juridique : SAS
              <br />
              Activité (NAF / APE) : Restauration de type rapide – 5610C
              <br />
              Inscription au RCS : greffe de BORDEAUX depuis le 16/05/2024
              <br />
              Capital social : 100,00 €
              <br />
              Adresse du siège social : 5 Hameau du Château de Tastes, Lieu-dit Les Grotte, 33410 Sainte-Croix-du-Mont
              <br />
              Dirigeante : Juliette LABROUSSE
              <br />
              Email : lostreadegustation@gmail.com
              <br />
              Téléphone : 07 86 68 57 13
              <br />
              Directeur de la publication : Juliette LABROUSSE
            </p>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Créateur et développement du site</h2>
            <p>
              Entrepreneur individuel
              <br />
              Fabien FEYSSAGUET
              <br />
              SIREN : 940 972 581
              <br />
              SIRET : 940 972 581 00026
              <br />
              Numéro de TVA : FR87940972581
              <br />
              Activité (NAF / APE) : Programmation informatique – 6201Z
              <br />
              Adresse : 48 Chemin de Cante Gric, 33320 Le Taillan-Médoc
            </p>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Hébergeur du site</h2>
            <p>
              Le site est hébergé via Lovable Cloud, un service qui déploie votre application sur une infrastructure
              cloud fournie par des prestataires tiers, notamment Supabase, et non exclusivement sur des serveurs gérés
              directement par Lovable. Vos données applicatives sont stockées et traitées sur cette infrastructure
              tierce conformément à la politique de confidentialité de Lovable et de Supabase.
              <br />
              Adresse : 548 Market St #99714, San Francisco, CA 94104, USA.
              <br />
              Contact : support@lovable.dev
              <br />
            </p>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Location de domaine</h2>
            <p>
              Domaine : OVH SAS
              <br />
              Adresse : 2 rue Kellermann, 59100 Roubaix, France
              <br />
              Téléphone : +33 9 72 10 10 07
              <br />
              Site web : ovh.com
            </p>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu du site, incluant notamment les textes, images, photographies, illustrations, logos,
              graphismes, vidéos et icônes, est la propriété exclusive de L'Ostrea Dégustation ou de ses partenaires.
            </p>
            <p>
              Certaines images utilisées sur le site sont la propriété de leurs auteurs respectifs et sont utilisées
              avec autorisation expresse. C'est notamment le cas de la photographie du Château Fort de Roquetaillade,
              ainsi que des clichés réalisés par{" "}
              <a
                href="https://www.instagram.com/com_aude?igsh=eWJlOGhlbG4xcHVw"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-ochre transition-colors"
              >
                @com_aude
              </a>
              .
            </p>
            <p>
              Toute reproduction, représentation, modification, publication, transmission, dénaturation totale ou
              partielle du site ou de son contenu, par quelque procédé que ce soit, est interdite sans autorisation
              écrite préalable de L'Ostrea Dégustation.
            </p>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Responsabilité</h2>
            <p>
              L'Ostrea Dégustation met tout en œuvre pour garantir l'exactitude et la mise à jour des informations
              publiées sur ce site.
            </p>
            <p>Cependant, l'éditeur ne peut être tenu responsable :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>des erreurs ou omissions présentes sur le site</li>
              <li>des dommages directs ou indirects liés à l'utilisation du site</li>
              <li>des contenus provenant de sites externes vers lesquels des liens sont proposés</li>
            </ul>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Données personnelles et vie privée</h2>
            <p>Le site ne collecte pas de données personnelles directement via des formulaires.</p>
            <p>
              Pour suivre l'activité du site et améliorer l'expérience utilisateur, nous utilisons l'outil de mesure
              d'audience <strong>Umami Analytics</strong>. Cet outil est configuré pour être strictement anonyme et
              fonctionne sans dépôt de cookies.
            </p>
            <p>
              Les statistiques collectées sont agrégées et incluent notamment le nombre de visiteurs, les pages vues, la
              source de provenance et la durée de visite (mesurée via un signal technique "heartbeat" anonyme). Ces
              données ne permettent en aucun cas d'identifier les visiteurs individuellement et les adresses IP sont
              immédiatement anonymisées.
            </p>
            <p>
              Pour plus de détails sur le traitement de ces données et vos droits, consultez la{" "}
              <Link to="/politique-de-confidentialite" className="text-ochre hover:text-ochre-dark underline font-bold">
                Politique de confidentialité
              </Link>
              .
            </p>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Contact</h2>
            <p>Pour toute question relative aux mentions légales ou au site :</p>
            <p>
              Email : lostreadegustation@gmail.com
              <br />
              Téléphone : 07 86 68 57 13
              <br />
              Adresse postale : 5 Hameau du Château de Tastes, Lieu-dit Les Grotte, 33410 Sainte-Croix-du-Mont
            </p>

            <h2 className="text-2xl font-serif text-warm-brown mt-10 mb-4">Loi applicable</h2>
            <p>
              Le présent site et ses mentions légales sont régis par la loi française. Tout litige relatif à
              l'utilisation du site sera soumis aux juridictions compétentes françaises.
            </p>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;
